<script setup lang="ts">
import type { IconSize, TpgClickEvent } from '@tpg/grammar-web';
import type { IconConstant } from '@tpg/grammar-web-icons';
import { computed } from 'vue';

export interface GrammarQuaternaryButtonProps {
  activated?: boolean;
  label?: string;
  ariaLabel?: string;
  disabled?: boolean;
  iconTemplate?: IconConstant | '';
  iconPosition?: 'leading' | 'trailing' | 'top';
  iconOnlySize?: IconSize;
  size?: 'x-small' | 'small' | 'regular' | 'overlay';

  // Custom
  iconColor?: string;
}

const props = withDefaults(defineProps<GrammarQuaternaryButtonProps>(), {
  activated: false,
  label: '',
  ariaLabel: '',
  disabled: false,
  iconTemplate: '',
  iconPosition: 'leading',
  iconOnlySize: 'large',
  size: 'regular',
  iconColor: '',
});

const emit = defineEmits<{
  (event: 'click', data: TpgClickEvent): void;
}>();

function onClick(event: TpgClickEvent) {
  emit('click', event);
}

const webComponentProps = computed(() => {
  const supportedProps: Omit<GrammarQuaternaryButtonProps, 'iconColor'> = {
    activated: props.activated,
    label: props.label,
    ariaLabel: props.ariaLabel,
    disabled: props.disabled,
    iconTemplate: props.iconTemplate,
    iconPosition: props.iconPosition,
    iconOnlySize: props.iconOnlySize,
    size: props.size,
  };
  return supportedProps;
});
</script>

<template>
  <tpg-quaternary-button
    class="inline-block"
    :style="
      iconColor
        ? `
--buttonQuaternaryColorForegroundRegularEnabled: ${iconColor};
--buttonQuaternaryColorForegroundRegularHover: ${iconColor};
--buttonQuaternaryColorForegroundRegularPressed: ${iconColor};
          `
        : ''
    "
    v-bind="webComponentProps"
    @tpg-click="onClick"
  />
</template>
